<template>
  <v-app id="inspire">
    <v-card-title>
      Clubs
      <v-spacer></v-spacer>
      <v-btn @click="changePathEditClub()" color="secondary"> Add New </v-btn>
      <v-spacer></v-spacer>

      <v-select
        v-model="orgFilter"
        label="Organization"
        :items="getOrganizations"
        v-on:change="filterChangeOrganization"
        item-text="name"
        clearable
        persisten-hint
        return-object
        hide-details
      ></v-select>
      <v-spacer></v-spacer>
      <v-select
        label="Club group"
        v-model="clubFilter"
        v-on:change="filterChangeEntityType"
        :items="getEntityTypes"
        item-text="name"
        return-object
        clearable
        persisten-hint
        hide-details
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="filteredClubList"
      :hide-default-footer="true"
      disable-pagination
      item-key="id"
    >
      <template v-slot:item.image="{ item }">
        <img v-if="item.image" :src="item.image" style="width: 50px; height: 50px" />
      </template>
      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active">mdi-check</v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </template>
      <!-- ACTIONS -->
      <template v-slot:item.actions="{ item }">
        <!-- DELETE organization BUTTON-->
        <div id="editTemplateRow" class="row">
          <div class="col-2">
            <v-btn icon @click="changePathEditClub(item.id)" color="secondary"><v-icon>mdi-pencil</v-icon></v-btn>
          </div>
          <div class="col-1">
            <v-btn icon @click="deleteShootingEntity(item.id)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </div>
      </template>
    </v-data-table>
    <c-confirmation-dialog ref="confirmationDialog"></c-confirmation-dialog>
  </v-app>
</template>

<script>
  import { GET_ENTITIES, DELETE_ENTITY, GET_ORGANIZATIONS, GET_ENTITY_TYPES } from '../../graphql/organizationQueries';

  export default {
    components: {
      CConfirmationDialog: () => import('../common/CConfirmationDialog'),
    },
    data() {
      return {
        id: '',
        search: '',
        orgFilter: null,
        clubFilter: null,
        getEntities: [],
        headers: [
          { text: 'Image', value: 'image', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left', sortable: false },
          { text: 'Governor', value: 'governorEntityId', align: 'left', sortable: false },
          { text: 'Active', value: 'active', align: 'left', sortable: false },
          {
            text: '',
            value: 'actions',
            sortable: false,
          },
        ],
      };
    },
    apollo: {
      $client: 'organizationClient',
      getEntities: {
        query: GET_ENTITIES,
        loadingKey: 'loading',
      },
      getOrganizations: {
        query: GET_ORGANIZATIONS,
        loadingKey: 'loading',
      },
      getEntityTypes: {
        query: GET_ENTITY_TYPES,
        loadingKey: 'loading',
      },
    },
    created() {
      //Set filter values using stored sessions
      if (this.$session.get('organization')) {
        this.orgFilter = this.$session.get('organization');
      }

      if (this.$session.get('entityType')) {
        this.clubFilter = this.$session.get('entityType');
      }
      this.$apollo.queries.getEntities.refetch();
      this.$apollo.queries.getOrganizations.refetch();
      this.$apollo.queries.getEntityTypes.refetch();
    },
    computed: {
      filteredClubList() {
        //Filter list of clubs based on organization and entity type. Both fields are required
        if (!this.orgFilter || !this.clubFilter) {
          return [];
        }

        let filterList = this.getEntities;
        if (this.orgFilter) filterList = filterList.filter((ent) => ent.organizationId === this.orgFilter.id);
        if (this.clubFilter) filterList = filterList.filter((ent) => ent.entityTypeId === this.clubFilter.id);
        return filterList;
      },
    },
    methods: {
      filterChangeOrganization(organization) {
        this.$session.set('organization', organization);
      },
      filterChangeEntityType(entityType) {
        this.$session.set('entityType', entityType);
      },
      async deleteShootingEntity(id) {
        if (await this.$refs.confirmationDialog.open('Are you sure you want to delete this club?')) {
          try {
            await this.$apollo.mutate({
              mutation: DELETE_ENTITY,
              variables: {
                id: id,
              },
            });
          } catch (err) {
            alert('Error deleting template! ' + err.message);
          }
          this.$apollo.queries.getEntities.refetch();
        }
      },
      changePathEditClub(id) {
        let pathURL = '/addoreditclub/';
        if (id) {
          pathURL += id;
        }
        this.$router.push({ path: pathURL });
      },
    },
  };
</script>

<style scoped>
  @media only screen and (max-width: 1000px) {
    #editTemplateRow {
      width: 10%;
    }
  }
</style>
